export default __webpack_public_path__ + "static/media/monkey.7f1c40a8.svg";